// extracted by mini-css-extract-plugin
module.exports = {"button":"SliderButton_button__me_WK","icon":"SliderButton_icon__8pjnT","iconText":"SliderButton_iconText__6Y8m0"};